import * as o from "react";

var t = o.createContext(null),
    e = function e() {
  var e = o.useContext(t);
  if (!e) throw new Error("`useCustomComponents` cannot be used outside of a `CustomComponentsContext.Provider`");
  return e;
};

export { t as CustomComponentsContext, e as useCustomComponents };